(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bold-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__forgeBoldFaq) return;
    window.__forgeBoldFaq = true;

    function setOpen(item, open) {
      var trigger = item.querySelector('[data-bold-faq-trigger]');
      var panel = item.querySelector('[data-bold-faq-panel]');
      if (!trigger || !panel) return;
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    function closeOthers(list, except) {
      list.querySelectorAll('[data-bold-faq-item].is-open').forEach(function (openItem) {
        if (openItem !== except) setOpen(openItem, false);
      });
    }

    function itemFromEvent(event) {
      var origin = event.target;
      if (!origin) return null;
      if (origin.nodeType !== 1) origin = origin.parentElement;
      if (!origin || !origin.closest) return null;
      if (origin.closest('[data-bold-faq-panel]')) return null;
      return origin.closest('[data-bold-faq-item]');
    }

    document.addEventListener('click', function (event) {
      var item = itemFromEvent(event);
      if (!item) return;
      var list = item.closest('[data-bold-faq]');
      if (!list) return;
      var isOpen = item.classList.contains('is-open');
      closeOthers(list, item);
      setOpen(item, !isOpen);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var item = itemFromEvent(event);
      if (!item && event.detail && event.detail.blockId) {
        var byId = document.getElementById('shopify-block-' + event.detail.blockId);
        if (byId) {
          item = byId.hasAttribute('data-bold-faq-item')
            ? byId
            : byId.closest('[data-bold-faq-item]') || byId.querySelector('[data-bold-faq-item]');
        }
      }
      if (!item) return;
      var list = item.closest('[data-bold-faq]');
      if (!list) return;
      closeOthers(list, item);
      setOpen(item, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.itemsPerView = 3;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dotsContainer = this.querySelector('[data-dots]');
      this.cards = Array.from(this.track.children);

      this.updateItemsPerView();
      this.createDots();
      this.updateCarousel();
      this.setupEventListeners();

      this.resizeObserver = new ResizeObserver(() => {
        this.updateItemsPerView();
        this.createDots();
        this.updateCarousel();
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateItemsPerView() {
      const width = window.innerWidth;
      if (width <= 749) {
        this.itemsPerView = 1;
      } else if (width <= 989) {
        this.itemsPerView = 2;
      } else {
        this.itemsPerView = 3;
      }
    }

    createDots() {
      this.dotsContainer.innerHTML = '';
      const totalDots = Math.max(0, this.cards.length - this.itemsPerView + 1);

      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'reviews-carousel__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to review ${i + 1}`);
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateCarousel();
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }

    setupEventListeners() {
      this.prevButton.addEventListener('click', () => {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateCarousel();
        }
      });

      this.nextButton.addEventListener('click', () => {
        const maxIndex = this.cards.length - this.itemsPerView;
        if (this.currentIndex < maxIndex) {
          this.currentIndex++;
          this.updateCarousel();
        }
      });
    }

    updateCarousel() {
      if (this.cards.length === 0) return;

      const cardWidth = this.cards[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;

      const maxIndex = this.cards.length - this.itemsPerView;
      this.prevButton.disabled = this.currentIndex === 0;
      this.nextButton.disabled = this.currentIndex >= maxIndex;

      const dots = this.dotsContainer.querySelectorAll('.reviews-carousel__dot');
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-selected', index === this.currentIndex ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('reviews-carousel-component')) {
    customElements.define('reviews-carousel-component', ReviewsCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.cardsPerView = parseInt(this.dataset.cardsDesktop) || 3;
      this.cardsPerViewTablet = parseInt(this.dataset.cardsTablet) || 2;
    }

    connectedCallback() {
      this.track = this.querySelector('.testimonials-slider__track');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.cards = this.querySelectorAll('.testimonials-slider__card');
      this.totalCards = this.cards.length;

      if (this.totalCards === 0) return;

      this.updateCardsPerView();
      this.setupEventListeners();
      this.updateButtons();

      window.addEventListener('resize', () => {
        this.updateCardsPerView();
        this.updateSlider();
      });
    }

    updateCardsPerView() {
      if (window.innerWidth <= 749) {
        this.activeCardsPerView = 1;
      } else if (window.innerWidth <= 989) {
        this.activeCardsPerView = this.cardsPerViewTablet;
      } else {
        this.activeCardsPerView = this.cardsPerView;
      }

      const maxIndex = Math.max(0, this.totalCards - this.activeCardsPerView);
      if (this.currentIndex > maxIndex) {
        this.currentIndex = maxIndex;
      }
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      let startX = 0;
      let currentX = 0;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    next() {
      if (this.currentIndex < this.totalCards - this.activeCardsPerView) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    updateSlider() {
      const card = this.cards[0];
      if (!card) return;

      const cardWidth = card.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= this.totalCards - this.activeCardsPerView;
      }
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  class UgcCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.trackWrapper = this.querySelector('.ugc-gallery__track-wrapper');
      this.track = this.querySelector('.ugc-gallery__track');
      this.items = Array.from(this.querySelectorAll('.ugc-gallery__item'));
      this.originalItemCount = Math.floor(this.items.length / 2); // Half are duplicates
      this.prevButton = this.querySelector('.ugc-gallery__control--prev');
      this.nextButton = this.querySelector('.ugc-gallery__control--next');
      this.dotsContainer = this.querySelector('.ugc-gallery__dots');
      this.isTransitioning = false;
      
      this.init();
    }

    init() {
      if (this.items.length === 0) return;

      this.setupEventListeners();
      this.setupDots();
      this.updateCarousel();
      this.setupVideos();
      
      // Handle resize
      this.resizeObserver = new ResizeObserver(() => this.updateCarousel());
      this.resizeObserver.observe(this.trackWrapper);
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      // Touch events for mobile swipe
      let startX = 0;
      let currentX = 0;
      
      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });
    }

    setupDots() {
      if (!this.dotsContainer) return;
      
      const totalDots = this.originalItemCount;
      
      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'ugc-gallery__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateCarousel();
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }

    setupVideos() {
      const videoContainers = this.querySelectorAll('.ugc-gallery__video-container');
      
      videoContainers.forEach(container => {
        const video = container.querySelector('video');
        const youtubeIframe = container.querySelector('.ugc-gallery__video--youtube');
        const playButton = container.querySelector('.ugc-gallery__play-button');
        
        // Skip YouTube videos - they handle their own playback
        if (youtubeIframe) {
          container.classList.add('is-playing');
          return;
        }
        
        // Handle regular video elements
        if (!video || !playButton) return;

        playButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            container.classList.add('is-playing');
          } else {
            video.pause();
            container.classList.remove('is-playing');
          }
        });

        video.addEventListener('click', () => {
          if (!video.paused) {
            video.pause();
            container.classList.remove('is-playing');
          }
        });

        video.addEventListener('ended', () => {
          // Video will loop, so keep playing state
          container.classList.add('is-playing');
        });
      });
      
      // Update videos when carousel changes - this will autoplay visible videos
      this.updateVideosVisibility();
    }

    updateVideosVisibility() {
      const visibleItems = this.getVisibleItems();
      const startIndex = this.currentIndex;
      const endIndex = Math.min(this.items.length, startIndex + visibleItems);
      
      this.items.forEach((item, index) => {
        const videoContainer = item.querySelector('.ugc-gallery__video-container');
        if (!videoContainer) return;
        
        const video = videoContainer.querySelector('video');
        const youtubeIframe = videoContainer.querySelector('.ugc-gallery__video--youtube');
        
        const isVisible = index >= startIndex && index < endIndex;
        
        // Handle YouTube videos (iframe)
        if (youtubeIframe) {
          if (isVisible) {
            videoContainer.classList.add('is-playing');
            // YouTube videos autoplay via URL parameters, no JS needed
          } else {
            // Pause YouTube video by reloading iframe without autoplay
            const currentSrc = youtubeIframe.src;
            if (currentSrc.includes('autoplay=1')) {
              youtubeIframe.src = currentSrc.replace('autoplay=1', 'autoplay=0');
            }
            videoContainer.classList.remove('is-playing');
          }
          return;
        }
        
        // Handle regular video elements
        if (!video) return;
        
        if (isVisible) {
          // Video is visible, try to play
          if (video.paused) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.then(() => {
                videoContainer.classList.add('is-playing');
              }).catch(() => {
                // Autoplay prevented
                videoContainer.classList.remove('is-playing');
              });
            }
          }
        } else {
          // Video is not visible, pause it
          if (!video.paused) {
            video.pause();
            videoContainer.classList.remove('is-playing');
          }
        }
      });
    }

    getVisibleItems() {
      const width = this.trackWrapper.offsetWidth;
      if (width < 750) return 1;
      if (width < 990) return 2;
      return 3;
    }

    prev() {
      if (this.isTransitioning) return;
      this.currentIndex -= 1;
      
      // Handle infinite loop - if going before start, jump to end of duplicates
      if (this.currentIndex < 0) {
        this.currentIndex = this.originalItemCount + this.currentIndex;
      }
      
      this.updateCarousel();
    }

    next() {
      if (this.isTransitioning) return;
      this.currentIndex += 1;
      
      // Handle infinite loop - if going past end of originals, continue through duplicates
      // Reset will happen after transition completes
      this.updateCarousel();
    }

    updateCarousel() {
      if (this.isTransitioning) return;
      
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const itemStep = itemWidth + gap;
      
      // Check if we need to reset (scrolled into duplicates)
      const needsReset = this.currentIndex >= this.originalItemCount;
      
      const offset = -(this.currentIndex * itemStep);
      
      this.isTransitioning = true;
      this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      this.track.style.transform = `translateX(${offset}px)`;

      this.updateUI();
      
      setTimeout(() => {
        this.isTransitioning = false;
        
        // Reset seamlessly after animation completes
        if (needsReset) {
          // Calculate the equivalent position in originals
          const targetIndex = this.currentIndex - this.originalItemCount;
          const targetOffset = -(targetIndex * itemStep);
          
          // Reset to original position (visually identical, so no jump)
          this.currentIndex = targetIndex;
          this.track.style.transition = 'none';
          this.track.style.transform = `translateX(${targetOffset}px)`;
          // Force reflow
          this.track.offsetHeight;
          // Restore transition for next animation
          this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        }
      }, 500);
    }

    updateUI() {
      // Buttons are always enabled for infinite scroll
      if (this.prevButton) this.prevButton.disabled = false;
      if (this.nextButton) this.nextButton.disabled = false;

      // Update dots based on original item count
      const dots = this.dotsContainer?.querySelectorAll('.ugc-gallery__dot');
      if (dots) {
        const normalizedIndex = ((this.currentIndex % this.originalItemCount) + this.originalItemCount) % this.originalItemCount;
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === normalizedIndex);
        });
      }
      
      // Update video visibility/playback
      this.updateVideosVisibility();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define('ugc-carousel', UgcCarousel);

  } catch(e) { console.error(e); }
})();
})();
